import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Tab, Tabs } from '@blueprintjs/core'

import styles from './buttonTabs.module.scss'

class ButtonTabs extends Component {
    static propTypes = {
        id: PropTypes.string.isRequired,
        children: PropTypes.arrayOf(Tab).isRequired,
        defaultActiveTab: PropTypes.string.isRequired,
        onTabChange: PropTypes.func,
    }

    state = {
        selectedTabId: null,
    }

    componentDidMount() {
        const { defaultActiveTab } = this.props

        this.setState({ selectedTabId: defaultActiveTab })
    }

    handleTabChange = (selectedTabId) => {
        const { onTabChange } = this.props

        this.setState({ selectedTabId })
        onTabChange(selectedTabId)
    }

    render() {
        const { selectedTabId } = this.state
        const { children, id } = this.props

        return (
            <Tabs
                id={id}
                onChange={this.handleTabChange}
                selectedTabId={selectedTabId}
                className={styles.tabs}
            >
                {children}
            </Tabs>
        )
    }
}

export default ButtonTabs
